module.exports = __webpack_public_path__ + "static/media/disdik-logo-border-clean.ebc723ce.png";